export function InitialiseCustomValidators() {
  // Guard clause for pages without any validation
  if (!($.validator && $.validator.unobtrusive)) {
    return;
  } //Boolean MustBeTrue Validation for form checkboxes


  $.validator.unobtrusive.adapters.add('mustbetrue', [], function (options) {
    options.rules['mustbetrue'] = {};
    options.messages['mustbetrue'] = options.message;
  });
  $.validator.addMethod('mustbetrue', function (value, element, params) {
    return element.checked;
  });
}